import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * The old org-scoped System Settings URLs (`/org/:orgId/system-settings/*`)
 * redirect to their org-less home `/system-settings/*` (docs/NAVIGATION.md
 * "Off-org navigation"), keeping the rest of the path, the query (`?tab=`) and
 * the hash, so bookmarks and links in old emails keep working. Mounted inside
 * OrgLayout, so the org in the old URL stays selected for the back link.
 * Carbon formulas is the org's own data and moved to the org's Settings
 * instead (`/org/:orgId/settings/carbon-formulas`).
 */
export function SystemSettingsRedirect() {
  const params = useParams();
  const { search, hash } = useLocation();
  const rest = params['*'] ?? '';
  const base = rest === 'carbon-formulas' || rest.startsWith('carbon-formulas/') ? '../settings' : '/system-settings';
  return <Navigate to={`${base}/${rest}${search}${hash}`} replace />;
}
